import { MaxUint256 } from '@ethersproject/constants';
import { getGasOverride } from '@silo/contract-utils';
import { SiloIncentivesController, SiloIncentivesController__factory } from '@silo/typechain';
import { ChecksumAddress, ClientProvider, SigningProvider } from '@silo/types';
import { getProviderOrSigner } from '@silo/web3';
import { ethers } from 'ethers';

interface ClaimRewardsParams {
  siloIncentivesControllerAddress: ChecksumAddress;
  clientProvider: ClientProvider;
  signingProvider: SigningProvider;
  shareTokenAddresses: ChecksumAddress[];
  account: ChecksumAddress;
}

/**
 * TODO: create helper fn for contract read/writes
 */
export const claimRewards = async ({
  siloIncentivesControllerAddress,
  clientProvider,
  signingProvider,
  shareTokenAddresses,
  account,
}: ClaimRewardsParams) => {
  const SiloIncentivesControllerContract = <SiloIncentivesController>(
    new ethers.Contract(
      siloIncentivesControllerAddress,
      SiloIncentivesController__factory.abi,
      getProviderOrSigner(signingProvider, account)
    )
  );

  const populatedTx = await SiloIncentivesControllerContract.populateTransaction.claimRewards(
    shareTokenAddresses,
    MaxUint256,
    account
  );

  const gasOverride = await getGasOverride(clientProvider, populatedTx);

  const tx = await SiloIncentivesControllerContract.claimRewards(shareTokenAddresses, MaxUint256, account, gasOverride);

  const { status } = await tx.wait();

  if (status === 0) {
    // see https://docs.ethers.org/v5/api/providers/types/#providers-TransactionReceipt
    throw new Error(`Transaction ${tx.hash} reverted`);
  }

  return tx;
};
